module.exports = __webpack_public_path__ + "public/Icons/manage_static_content.svg?9bbe7464";